<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      color="lotojr_colorPrimaryShade"
    >
      <v-list v-if="isAdmin">
        <v-list-item
          v-for="route in adminRoutes"
          :key="route.path"
          @click="navigateTo(route.path)"
        >
          <v-list-item-title v-if="route.path">{{
            route.title
          }}</v-list-item-title>
          <v-list-group v-else-if="route.sub" :value="true" id="aaaa">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Relatórios</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="route in route.children"
              :key="route.path"
              @click="navigateTo(route.path)"
            >
              <v-list-item-title>{{ route.title }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list-item>
      </v-list>
      <v-list v-else>
        <v-list-group :value="true" no-action sub-group>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Relatórios</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="route in socioRoutes"
            :key="route.path"
            @click="navigateTo(route.path)"
          >
            <v-list-item-title>{{ route.title }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="lotojr_colorPrimary"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <div class="d-flex align-center" style="margin-right: 50px;">
        <v-img
          :src="require('../../assets/rsz_logo.png')"
          class="my-3"
          contain
          width="100"
        />
      </div>
      <v-spacer></v-spacer>
      <div class="text-xs-center">
        <v-menu
          v-model="menu"
          :close-on-content-click="true"
          :close-on-click="closeOnClickValue"
          :nudge-width="200"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon large>account_circle</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-list>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon large>account_circle</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="profile-item">{{
                    name
                  }}</v-list-item-title>
                  <v-list-item-subtitle>{{ username }}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <app-profile
                    :closeOnClickMethod="closeOnClick"
                    :closeMenuMethod="closeMenu"
                  ></app-profile>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn text color="primary" @click="logout">Sair</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-menu>
      </div>
    </v-app-bar>

    <v-content class="grey lighten-2">
      <router-view></router-view>
    </v-content>
    <app-notification></app-notification>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Profile from "../../views/profile/Profile";
import router from "@/router";
import Notification from "../Notification";
export default {
  components: {
    "app-profile": Profile,
    "app-notification": Notification,
  },
  data: () => ({
    menu: false,
    dialog: false,
    drawer: null,
    closeOnClickValue: true,
    adminRoutes: [
      { path: "/loterias", title: "Loterias" },
      { path: "/estatisticas", title: "Estatisticas" },
      { path: "/clientes", title: "Clientes" },
      { path: "/socios", title: "Socios" },
      { path: "/concursos", title: "LOTOJR" },
      { path: "/concursolotojr", title: "LOTOJR NOVO" },
      { path: "/saquelotojr", title: "Saque LotoJR" },
      { path: "/apoiadorplano", title: "Apoiador Planos" },
      { path: "/padroes", title: "Padrões" },
      { path: "/bolao", title: "Bolão" },
      { path: "/empresa", title: "Empresa" },
      { path: "/saque", title: "Saques" },
      { path: "/conciliacao", title: "Conciliação" },
      { path: "/caixa", title: "Caixa" },
      {
        path: null,
        sub: true,
        title: "Relatórios",
        children: [
          { path: "/relatorioAposta", title: "Apostas" },
          { path: "/relatorioPremium", title: "Premium" },
        ],
      },
    ],
    socioRoutes: [
      { path: "/relatorioAposta", title: "Apostas" },
      { path: "/relatorioCaixa", title: "Caixa" },
      { path: "/relatorioPremium", title: "Premium" },
    ],
  }),
  mounted() {
    console.log("navi");
  },
  computed: {
    ...mapGetters({
      session: "session",
    }),
    name: function() {
      return this.session.user ? this.session.user.name : "";
    },
    username: function() {
      return this.session.user ? this.session.user.username : "";
    },
    isAdmin: function() {
      return this.session.user.acesso == 4;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("signUserOut");
      this.$router.go("/signin");
    },
    navigateTo(path) {
      this.$router.push(path);
    },
    closeOnClick() {
      this.closeOnClickValue = false;
    },
    closeMenu() {
      this.closeOnClickValue = true;
      this.menu = false;
    },
  },
};
</script>

<style scoped>
.v-list-item__title {
  color: white !important;
}
.profile-item {
  color: black !important;
}
</style>
